import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { LogIn, LogOut, XCircle, Plus, Pencil, Trash2, Save, Database, Filter } from "lucide-react";

const iconFor = (action) => {
  if (action === "login") return { Icon: LogIn, color: "maroon" };
  if (action === "logout") return { Icon: LogOut, color: "zinc" };
  if (action === "login_failed") return { Icon: XCircle, color: "red" };
  if (action === "create") return { Icon: Plus, color: "blue" };
  if (action === "update") return { Icon: Pencil, color: "amber" };
  if (action === "delete") return { Icon: Trash2, color: "red" };
  if (action === "backup") return { Icon: Save, color: "maroon" };
  if (action === "restore") return { Icon: Database, color: "amber" };
  return { Icon: Pencil, color: "zinc" };
};

const AdminActivity = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/activity", { params: filter ? { action: filter } : {} });
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const purge = async () => {
    if (!window.confirm("Hapus log yang lebih tua dari 30 hari?")) return;
    const { data } = await api.delete("/activity/purge", { params: { before_days: 30 } });
    toast.success(`${data.deleted} log lama dihapus`);
    load();
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-8">
        <div>
          <h1 className="text-3xl font-display font-bold">Activity Log</h1>
          <p className="mt-1 text-sm text-zinc-500">Riwayat login, logout, dan perubahan data oleh admin.</p>
        </div>
        <button onClick={purge} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-zinc-300 text-zinc-700 font-semibold hover:bg-zinc-100 text-sm">
          <Trash2 size={14} /> Bersihkan log > 30 hari
        </button>
      </div>

      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center gap-2 bg-white rounded-full px-3 py-1 border border-zinc-200">
          <Filter size={14} className="text-zinc-500" />
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="text-sm outline-none bg-transparent">
            <option value="">Semua aksi</option>
            <option value="login">Login</option>
            <option value="login_failed">Login Gagal</option>
            <option value="logout">Logout</option>
            <option value="create">Create</option>
            <option value="update">Update</option>
            <option value="delete">Delete</option>
            <option value="backup">Backup</option>
            <option value="restore">Restore</option>
          </select>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-zinc-200 overflow-hidden">
        {loading ? (
          <div className="text-center py-16 text-zinc-500 text-sm">Memuat...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 text-zinc-500 text-sm">Belum ada aktivitas.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 text-left text-xs uppercase tracking-wider text-zinc-500">
              <tr>
                <th className="p-4">Waktu</th>
                <th className="p-4">User</th>
                <th className="p-4">Aksi</th>
                <th className="p-4">Resource</th>
                <th className="p-4">Detail</th>
                <th className="p-4">IP</th>
              </tr>
            </thead>
            <tbody>
              {items.map((l) => {
                const { Icon, color } = iconFor(l.action);
                return (
                  <tr key={l.id} className="border-t border-zinc-100">
                    <td className="p-4 text-xs text-zinc-500 whitespace-nowrap">{new Date(l.created_at).toLocaleString("id-ID")}</td>
                    <td className="p-4 text-zinc-800 text-xs">{l.user_email || "-"}</td>
                    <td className="p-4">
                      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] font-bold uppercase bg-${color}-100 text-${color}-800`}>
                        <Icon size={12} /> {l.action}
                      </span>
                    </td>
                    <td className="p-4 text-zinc-600 text-xs">{l.resource || "-"}</td>
                    <td className="p-4 text-zinc-600 text-xs max-w-md truncate">{l.detail || l.resource_id || "-"}</td>
                    <td className="p-4 text-zinc-500 text-xs font-mono">{l.ip || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminActivity;
